import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Modal,
  Typography
} from '@mui/material';
import { green } from '@mui/material/colors';
import './gymCardDesign.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const GymCard = ({ title, email, imgsrc, active, gym, setGymInfo, setOpen,onDelete,  ...props }) => {
  return (
    <Card
      {...props}
      sx={{
        background: active && '#19cf1969',
        transition: '.5s',
        ':hover': {
          transform: 'scale(1.01)',
          borderRadius: '10px',
          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
        }
      }}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between', cursor: 'pointer' }}
        >
          <Grid item style={{ width: '100%' }}>
            <div className="cardHeader">
              <Typography color="textSecondary" gutterBottom variant="h6">
                {title}
              </Typography>
              {!active && <div className="icons">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setGymInfo(gym)
                    setOpen(true)
                  }}
                >
                  <EditIcon />
                </div>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(gym)
                  }}
                >
                  <DeleteIcon />
                </div>
              </div>}
            </div>
            <Typography color="textPrimary" variant="h3">
              {email ? email : '-'}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: green[600],
                height: 56,
                width: 56,
                borderRadius: '50%'
              }}
            >
              <img height={'100%'} width={'100%'} src={imgsrc} alt="gym logo" />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default GymCard;
